import { quoteIdentifier as C } from "./identifiers.js";
function I(t, e, c) {
  switch (e) {
    case ">":
    case "<":
    case "=":
    case ">=":
    case "<=":
    case "<>":
      return [
        `"${t}"`,
        e,
        typeof c == "string" ? `'${c}'` : c
      ].join(" ");
    case "LIKE":
      return [`"${t}"`, e, `%${c}%`].join(" ");
    case "IN":
      return [`"${t}"`, e, `(${c})`].join(" ");
    default:
      throw new Error(`Unsupported operator: ${e}`);
  }
}
function h(t, e, c, i, R, O) {
  const a = R[e] || e;
  let y = I(a, c, i);
  if (t === "whereIn") {
    const Q = typeof i[0] == "string" ? i.map((u) => `'${u}'`) : i;
    y = [`"${a}"`, "IN", `(${Q.join(", ")})`].join(" ");
  }
  if (t === "orWhere") {
    const Q = O.pop();
    if (Q)
      Q.type === "OR" && Q.query.slice(0, -1).concat(" OR ", y, ")"), O.push({
        type: "OR",
        query: "(".concat(Q.query.concat(" OR ", y, ")"))
      });
    else
      throw new Error("No previous query to OR with");
  } else
    O.push({
      type: "AND",
      query: y
    });
}
function b(t, e, c) {
  function i(u) {
    return function(n) {
      return {
        sqlQuery: u,
        // @ts-ignore
        transform: n || ((o) => o),
        nameMap: c
      };
    };
  }
  function R(...u) {
    const r = t.makeQuery(({ table: f }) => `SELECT ${u[0] === "*" ? "*" : u.map((s) => `"${String(e[s] || s)}"`).join(", ")} FROM "${f}"`).sqlQuery, n = [];
    let o = "";
    const $ = {
      where: q,
      done: d,
      orWhere: w,
      whereIn: S,
      orderBy: j
    };
    function d(f) {
      return {
        sqlQuery: r + (n.length ? ` WHERE ${n.map((s) => s.query).join(" AND ")}` : "") + o,
        // @ts-ignore
        transform: f || ((s) => s),
        nameMap: c
      };
    }
    function q(f, s, E) {
      return h("where", f, s, E, e, n), $;
    }
    function S(f, s) {
      return h(
        "whereIn",
        f,
        "IN",
        s,
        e,
        n
      ), { done: d };
    }
    function w(f, s, E) {
      return h("orWhere", f, s, E, e, n), $;
    }
    function j(f, s = "ASC") {
      const E = e[f];
      return o = `${o} ORDER BY "${E}" ${s}`, { done: d };
    }
    return { where: q, done: d, whereIn: S, orderBy: j };
  }
  function O(u, r) {
    const n = t.makeQuery(
      ({ table: o }) => `SELECT SUM(${e[u]}) as ${r} FROM "${o}"`
    ).sqlQuery;
    return { done: i(n) };
  }
  function a(u) {
    let r = t.makeQuery(
      ({ table: o }) => `SELECT DISTINCT "${e[u]}" FROM "${o}"`
    ).sqlQuery;
    function n(o, $ = "ASC") {
      const d = e[o];
      return r = `${r} ORDER BY "${d}" ${$}`, {
        done: i(r)
      };
    }
    return {
      done: i(r),
      orderBy: n,
      nameMap: c
    };
  }
  function y(u) {
    let r = t.makeQuery(
      ({ table: o }) => `SELECT ${u.map(($) => `"${String(e[$] || $)}"`).join(", ")} FROM "${o}" GROUP BY ${u.map(($) => `"${String(e[$] || $)}"`).join(", ")}`
    ).sqlQuery;
    function n(o, $) {
      const d = r.split(" FROM ");
      return r = d[0] + `, SUM("${String(e[o])}") as ${$} FROM ` + d[1], {
        done: i(r)
      };
    }
    return {
      done: i(r),
      sum: n
    };
  }
  function Q(u, r) {
    const n = t.makeQuery(u, r);
    return n.nameMap = c, n;
  }
  return { select: R, distinct: a, sum: O, groupBy: y, rawQuery: Q };
}
function l(t, e, c, i) {
  const R = Object.keys(i).reduce((a, y) => (a[i[y]] = y, a), {});
  function O(a, y) {
    return {
      sqlQuery: `${t ? `USE ${C(t, "database")}; ` : ""}${a(
        {
          columns: R,
          table: e
        }
      )}`,
      transform: y || ((Q) => Q)
    };
  }
  return b({ makeQuery: O }, R, i);
}
export {
  l as defineDuckDBTable
};
